module.exports = true;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/_library.js